
$(document).ready(function(){

	$('.section-faq .accordion-item .title').click(function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).parent().find('.content').slideToggle();
	});

	$('.section-featured .slider').slick({
		slidesToShow: 4,
		infinite: true,
		dots: false,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 6000,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			}
		]
	});

	$('.blog .slider').slick({
		slidesToShow: 3,
		infinite: true,
		dots: false,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 6000,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$("#getPDF").click(function(e){
		e.preventDefault();
		downloadPdf();
	});

const urlParams = new URLSearchParams(window.location.search);
const paramValue = urlParams.get('guide');
const selectElement = document.getElementById('pdfSelect');

if (paramValue && selectElement) {
    for (let i = 0; i < selectElement.options.length; i++) {
        const option = selectElement.options[i];

        if (option.textContent.trim() === paramValue.trim()) {
            option.selected = true;
            break;
        }
    }
}

	function downloadPdf() {
		const selectElement = document.getElementById('pdfSelect');
		
const fileName = selectElement?.value;

if (fileName) {
			const link = document.createElement('a');
			link.href = fileName;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			alert('Please select a PDF to download.');
		}
	}


});

/*
document.addEventListener('click', (event) => {
  // 1. Identify if the clicked element (or its parent) is our target button
  const btn = event.target.closest('.gf-option-box button[role="checkbox"]');
  
  if (btn) {
    setTimeout(() => {
      const isChecked = btn.getAttribute('aria-checked') === 'true' || btn.classList.contains('checked');
      const title = btn.getAttribute('title');

      if (isChecked) {
        console.log("Selected:", title);
      } else {
        console.log("Deselected:", title);
      }
    }, 10);
  }
});
*/

function applyBlogFilters() {
  // 1. Get titles and convert them all to lowercase immediately
  const activeFilters = Array.from(document.querySelectorAll('.gf-option-box button.checked, .gf-option-box button[aria-checked="true"]'))
                             .map(el => el.getAttribute('title')?.trim().toLowerCase())
                             .filter(Boolean); // Removes any null/undefined values

  const items = document.querySelectorAll('.blog-list li');

  items.forEach(item => {
    const rawCategory = item.getAttribute('data-category') || "";
    
    // 2. Convert item categories to lowercase as well
    const itemCategories = rawCategory.split(',')
                                      .map(cat => cat.trim().toLowerCase());

    // 3. Compare lowercase vs lowercase
    const hasMatch = itemCategories.some(cat => activeFilters.includes(cat));

    if (activeFilters.length === 0 || hasMatch) {
      item.style.setProperty('display', 'block', 'important');
    } else {
      item.style.setProperty('display', 'none', 'important');
    }
  });
}

// 3. The "Double-Tap" for AJAX: Run on load AND after a short delay
window.addEventListener('load', () => {
  applyBlogFilters();
  // Sometimes AJAX takes a second to finish after 'load'
  setTimeout(applyBlogFilters, 1000); 
});

document.addEventListener('click', (event) => {
  const btn = event.target.closest('.gf-option-box button');
  if (btn) {
    console.log("Button Clicked:", btn.getAttribute('title'));
    // Wait for the app's script to toggle the 'checked' class
    setTimeout(applyBlogFilters, 200);
  }
});